import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ThemeContext = createContext({ theme: 'light', toggleTheme: () => {} });

export const ThemeProvider = ({ children }) => {
	const [theme, setTheme] = useState(() => {
		const saved = localStorage.getItem('theme');
		return saved === 'dark' ? 'dark' : 'light';
	});

	useEffect(() => {
		localStorage.setItem('theme', theme);
		const root = document.documentElement;
		if (theme === 'dark') {
			root.classList.add('dark');
		} else {
			root.classList.remove('dark');
		}
	}, [theme]);

	const value = useMemo(
		() => ({
			theme,
			isDark: theme === 'dark',
			toggleTheme: () => setTheme(prev => (prev === 'dark' ? 'light' : 'dark')),
		}),
		[theme]
	);

	return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);


